<template>
  <div
    class="TempMsg flex justify-center fixed bottom-56 desk:bottom-24 z-globalError w-full cursor-pointer p-12"
    @click="uiStore.tempMsg = ''"
  >
    <div
        class="successmsg p-8 type-sm flex items-center justify-center gap-4 mobOnly:w-full shadow-lg outline outline-1"
        :class="{
        'bg-bg-success text-text-success outline-border-successStrong/10': uiStore.tempMsgType === 'success',
        'bg-bg-warning text-text-warning outline-border-warningStrong/10': uiStore.tempMsgType === 'warning',
        'bg-bg-error text-text-error outline-border-errorStrong/10': uiStore.tempMsgType === 'error',
        }"
    >
      <div class="p-4 shrink-0 self-start">
        <img
            :src="uiStore.tempMsgType === 'error' ? '/icons/warning.svg' : '/icons/check-circle-green.svg'"
            class="w-20 h-20"
            alt=""
        >
      </div>
      <div class="shrink grow"> {{ uiStore.tempMsg }} </div>
      <div class="ml-8 p-4 shrink-0 rounded-6 hover:bg-bg-successStrong/10 transition-all">
        <img
          src="/icons/close.svg"
          class="w-16 h-16"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';

const uiStore = useUiStore();

const closeIcon = computed((): string => {
  return uiStore.tempMsgType === 'error'
    ? '/icons/close-inv.svg'
    : '/icons/close.svg';
});

</script>